<template>
  <container :isModal="true" @close-modal="cancelar()" :loading="!stateReady">
    <template v-slot:header>
      <h3>Importar Trechos Planilha GovPass</h3>
    </template>
    <template v-slot:body>
      <div v-if="stateReady">
        <form @submit.prevent="submitSearch">
          <fieldset :disabled="stateLoading">
            <div class="p-formgrid p-grid">
              <div class="p-field p-fluid p-col-12 p-md-6 p-lg-3">
                <input-with-label label="Rodovia" v-slot="l">
                  <InputText
                    v-model="filter.rodovia"
                    :id="l.id"
                    :required="l.required"
                    v-focus
                  />
                </input-with-label>
              </div>
              <div class="p-field p-fluid p-col-12 p-md-6 p-lg-3">
                <input-with-label label="Nome" v-slot="l">
                  <InputText
                    v-model="filter.nome"
                    :id="l.id"
                    :required="l.required"
                  />
                </input-with-label>
              </div>
              <div class="p-field p-fluid p-col-12 p-md-6 p-lg-3">
                <input-with-label label="Km Inicial" v-slot="l">
                  <InputNumber
                    v-model="filter.kmInicial"
                    :id="l.id"
                    :required="l.required"
                    mode="decimal"
                    :minFractionDigits="0"
                    :maxFractionDigits="2"
                  />
                </input-with-label>
              </div>
              <div class="p-field p-fluid p-col-12 p-md-6 p-lg-3">
                <input-with-label label="Km Final" v-slot="l">
                  <InputNumber
                    v-model="filter.kmFinal"
                    :id="l.id"
                    :required="l.required"
                    mode="decimal"
                    :minFractionDigits="0"
                    :maxFractionDigits="2"
                  />
                </input-with-label>
              </div>
              <div class="p-col-12">
                <button-group>
                  <Button
                    type="submit"
                    class="p-button-rounded"
                    label="Buscar"
                  />
                  <Button
                    label="Limpar"
                    class="p-button-rounded p-button-text"
                    @click="clearFilter()"
                  />
                </button-group>
              </div>
            </div>
          </fieldset>
        </form>

        <div class="contador-selecionados p-mb-2">
          <span class="badge-contador">
            {{ qtdSelecionados }} trecho{{
              qtdSelecionados !== 1 ? "s" : ""
            }}
            selecionado{{ qtdSelecionados !== 1 ? "s" : "" }}
          </span>
        </div>

        <search-result
          :showSelector="false"
          :results="results"
          :loading="stateLoading"
          :keyParam="'idOrigem'"
          :breakpoint="'70rem'"
          :rowClassFunction="rowClass"
          @after-page-change="afterPageChange"
          @row-click="toggleTrecho"
        >
          <template v-slot:title> Trechos da Planilha GovPass </template>
          <template v-slot:columns>
            <Column
              header=""
              headerClass="p-header-center"
              style="width: 3rem; text-align: center"
            >
              <template #body="slotProps">
                <Checkbox
                  :binary="true"
                  :modelValue="isSelecionado(slotProps.data.idOrigem)"
                  style="pointer-events: none"
                />
              </template>
            </Column>
            <Column field="rodovia" header="Rodovia" style="width: 14rem">
              <template #body="slotProps">
                <div class="cell-visual">
                  <input-with-label label="Rodovia" v-slot="l">
                    <InputText
                      :modelValue="slotProps.data.rodovia"
                      :id="l.id"
                      readonly
                    />
                  </input-with-label>
                </div>
              </template>
            </Column>
            <Column field="idUnidadeFederal" header="UF" style="width: 8rem">
              <template #body="slotProps">
                <div class="cell-visual">
                  <input-with-label label="UF" v-slot="l">
                    <InputText
                      :modelValue="getUfSigla(slotProps.data.idUnidadeFederal)"
                      :id="l.id"
                      readonly
                    />
                  </input-with-label>
                </div>
              </template>
            </Column>
            <Column field="nmTrechoInicial" header="Nome">
              <template #body="slotProps">
                <div class="cell-visual">
                  <input-with-label label="Nome" v-slot="l">
                    <InputText
                      :modelValue="slotProps.data.nmTrechoInicial"
                      :id="l.id"
                      readonly
                    />
                  </input-with-label>
                </div>
              </template>
            </Column>
            <Column field="kmInicial" header="Km Inicial" style="width: 12rem">
              <template #body="slotProps">
                <div class="cell-visual">
                  <input-with-label label="Km Inicial" v-slot="l">
                    <InputNumber
                      :modelValue="slotProps.data.kmInicial"
                      :id="l.id"
                      readonly
                      :minFractionDigits="3"
                      :maxFractionDigits="3"
                    />
                  </input-with-label>
                </div>
              </template>
            </Column>
            <Column field="kmFinal" header="Km Final" style="width: 12rem">
              <template #body="slotProps">
                <div class="cell-visual">
                  <input-with-label label="Km Final" v-slot="l">
                    <InputNumber
                      :modelValue="slotProps.data.kmFinal"
                      :id="l.id"
                      readonly
                      :minFractionDigits="3"
                      :maxFractionDigits="3"
                    />
                  </input-with-label>
                </div>
              </template>
            </Column>
          </template>
          <template v-slot:actions>
            <Button
              label="Concluir seleção"
              class="p-button-rounded"
              @click="concluir()"
            />
          </template>
        </search-result>
      </div>
    </template>
  </container>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  Ref,
  toRefs
} from "vue";
import Checkbox from "primevue/checkbox";
import { PaginationResult, defaultResults } from "../../pagination";
import {
  usePlanilhaTrechosService,
  TrechoPayload,
  TrechoGovPassFilterPayload
} from "../../modules/business/trecho/planilhaTrechosBusiness";
import { useUfService } from "../../modules/business/common/commonBusiness";
import { useToast } from "../../modules/message";

const LIMITE_ALERTA_TRECHOS = 500;

interface SelectorTrechosGovPassState {
  results: PaginationResult<TrechoPayload>;
  filter: TrechoGovPassFilterPayload;
  page: number;
  selecionados: Record<number, TrechoPayload>;
  alerta500Disparado: boolean;
  stateReady: boolean;
  loadings: Array<Ref<boolean>>;
}

export default defineComponent({
  setup(props, { emit }) {
    const state = reactive<SelectorTrechosGovPassState>({
      results: defaultResults(),
      filter: usePlanilhaTrechosService().safeFilterTrechoGovPass(),
      page: 0,
      selecionados: {},
      alerta500Disparado: false,
      stateReady: false,
      loadings: []
    });

    const stateLoading = computed(() => {
      return state.loadings.length !== 0;
    });

    const qtdSelecionados = computed(() => {
      return Object.keys(state.selecionados).length;
    });

    const getUfSigla = (idUnidadeFederal?: number | null) => {
      return useUfService().getUfSigla(idUnidadeFederal ?? undefined);
    };

    const executeSearch = () => {
      const {
        data,
        loading,
        searchTrechosGovPass
      } = usePlanilhaTrechosService();
      state.loadings.push(loading);
      return searchTrechosGovPass(props.idPlanilhaMae, state.filter, state.page)
        .then(() => {
          state.results = data.value;
          state.page = state.results.page.number;
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    const submitSearch = () => {
      state.page = 0;
      state.results = defaultResults();
      return executeSearch();
    };

    const clearFilter = () => {
      state.filter = usePlanilhaTrechosService().safeFilterTrechoGovPass();
      submitSearch();
    };

    const afterPageChange = (page: number) => {
      state.page = page;
      executeSearch();
    };

    const isSelecionado = (idOrigem?: number | null) => {
      return idOrigem != null && !!state.selecionados[idOrigem];
    };

    const rowClass = (trecho: TrechoPayload) => {
      return isSelecionado(trecho?.idOrigem) ? "linha-selecionada" : "";
    };

    const verificaLimite = () => {
      if (
        qtdSelecionados.value > LIMITE_ALERTA_TRECHOS &&
        !state.alerta500Disparado
      ) {
        state.alerta500Disparado = true;
        useToast().warning(
          "A seleção possui mais de 500 trechos. A chance de reprovação é alta.",
          { life: 30000 }
        );
      }
    };

    const toggleTrecho = (trecho: TrechoPayload) => {
      const idOrigem = trecho.idOrigem;
      if (idOrigem == null) {
        return;
      }
      if (state.selecionados[idOrigem]) {
        delete state.selecionados[idOrigem];
      } else {
        state.selecionados[idOrigem] = trecho;
        verificaLimite();
      }
    };

    const concluir = () => {
      emit("confirmar-selecao", Object.values(state.selecionados));
    };

    const cancelar = () => {
      emit("cancelar-selecao");
    };

    onMounted(() => {
      (props.trechosJaSelecionados ?? []).forEach((t) => {
        if (t && t.idOrigem != null) {
          state.selecionados[t.idOrigem] = t;
        }
      });
      state.stateReady = true;
      submitSearch();
    });

    return {
      stateLoading,
      qtdSelecionados,
      getUfSigla,
      executeSearch,
      submitSearch,
      clearFilter,
      afterPageChange,
      isSelecionado,
      rowClass,
      toggleTrecho,
      concluir,
      cancelar,
      ...toRefs(state)
    };
  },
  props: {
    idPlanilhaMae: {
      type: Number,
      required: true
    },
    trechosJaSelecionados: {
      type: Array as () => Array<TrechoPayload>
    }
  },
  emits: ["confirmar-selecao", "cancelar-selecao"],
  components: { Checkbox }
});
</script>

<style scoped lang="scss">
.contador-selecionados {
  display: flex;
  justify-content: flex-end;
}

.badge-contador {
  font-size: $font-size-sm;
  font-weight: $font-weight-semibold;
  color: $primary;
  background: $bg-surface-secondary;
  padding: $space-1 $space-3;
  border-radius: $radius-full;
}

/* Celulas apenas visuais: caixinhas iguais as do cadastro, porem nao editaveis.
   pointer-events: none deixa o clique atravessar para a linha (selecao). */
.cell-visual {
  pointer-events: none;
}

/* A linha inteira e clicavel; evita realce de texto ao clicar repetido. */
:deep(.p-datatable-tbody > tr) {
  cursor: pointer;
  user-select: none;
}

:deep(.p-datatable-tbody > tr:hover) {
  background: $bg-surface-secondary;
}

/* Destaque da linha selecionada. */
:deep(.p-datatable-tbody > tr.linha-selecionada),
:deep(.p-datatable-tbody > tr.linha-selecionada:hover) {
  background: rgba(63, 81, 181, 0.1);
}
</style>
